import { render, staticRenderFns } from "./Socios.vue?vue&type=template&id=bc31d2ce&scoped=true"
import script from "./Socios.vue?vue&type=script&lang=js"
export * from "./Socios.vue?vue&type=script&lang=js"
import style0 from "./Socios.vue?vue&type=style&index=0&id=bc31d2ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc31d2ce",
  null
  
)

export default component.exports